module.exports = __webpack_public_path__ + "img/smile.25f728fa.svg";